
export enum PeticaoInicialFiltro {
  TODOS = 'TODOS',
  COM_PETICAO_INICIAL = 'COM_PETICAO_INICIAL',
  SEM_PETICAO_INICIAL = 'SEM_PETICAO_INICIAL'
}